export default "/_next/static/6ebe21b2dc8980f61ef5ee5ca262a466.svg";